// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".border-wrapper{border-top-left-radius:20px;border-right:0;padding:40px;padding-top:0;padding-bottom:30px}@media only screen and (max-width:1440px){.border-wrapper{border-top:unset;border-left:unset;border-top-left-radius:unset;border-right:unset;padding:unset;padding-top:unset;padding-bottom:unset}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
